import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  activeStepDataSelector,
  appRequestSelector,
} from "containers/MultistepForm/selectors";
import { nextStep } from "containers/MultistepForm/actions";
import { selectedOfferSelector } from "../../../selectors";
import { tokenSelector } from "../../../../EmbeddableWidget/selectors";
import { ProvidersApi } from "../../../../../api/providers";

import Form from "./Form";

class KafeneBankDataForm extends Component {
  state = {
    additionalData: {},
    valid: false,
    loadingLease: false,
  };

  buildRequestBody = () => {
    const { additionalData } = this.state;
    const { appRequest, offer, selectedOffer } = this.props;

    return {
      ...appRequest,
      ...offer,
      additional_info_data: {
        ...(offer.additional_info_data || {}),
        bankAccount: {
          routing: additionalData.routingNum,
          account: additionalData.accountNum,
        },
        agreementInfo: selectedOffer.agreementInfo || {},
      },
    };
  };

  submitForm = (e) => {
    const { valid } = this.state;
    const { token, nextStep, selectedOffer, offer } = this.props;
    e.preventDefault();
    if (valid) {
      this.setState({ loadingLease: true });
      const requestBody = this.buildRequestBody();

      return ProvidersApi.kafeneCreateApplication(token, { ...requestBody, app_id: offer.app_id })
        .then((resp) => {
          if (resp.approval_status === "approved") {
            return nextStep({
              step: "kafeneApprovedAppScreen",
              data: {
                ...selectedOffer,
                contractUrl: resp.contractUrl,
                application_id: resp.application_id,
                approval_amount: resp.approval_amount || selectedOffer.approved_amount,
                offer: resp.offer,
              },
            });
          }
          return nextStep({
            step: "kafeneDeniedAppScreen",
            data: selectedOffer,
          });
        })
        .catch(() => {
          return nextStep({
            step: "kafenePendingAppScreen",
            data: selectedOffer,
          });
        })
        .finally(() => {
          this.setState({ loadingLease: false });
        });
    }
  };

  setAdditionalData = (data) => {
    this.setState({
      additionalData: data.data,
      valid: data.valid,
    });
  };

  render() {
    const { loading } = this.props;
    const { valid, loadingLease } = this.state;

    return (
      <div className="kafene-bank-data-form">
        <div className="kafene-bank-data-form__header">
          <h1>
            Connect Your Checking Account{' '}
            <span className="required-badge">Required</span>
          </h1>
          <p className="kafene-bank-data-form__subtitle">
            Apply with the Primary Checking Account where you deposit your income, as this account will be used to assess your application.
          </p>
        </div>
        
        {/*<button className="kafene-bank-data-form__stripe-btn" type="button">*/}
        {/*  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>*/}
        {/*    <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>*/}
        {/*    <path d="M8 5V8L10 10" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>*/}
        {/*  </svg>*/}
        {/*  Safely Connect with Stripe 🔒*/}
        {/*</button>*/}

        <p className="kafene-bank-data-form__instruction">
          Enter the Routing and Account Numbers for your <strong>primary checking account</strong> below.
        </p>

        <Form onDataChange={this.setAdditionalData} />

        <div className="kafene-bank-data-form__notes">
          <p className="kafene-bank-data-form__note">
            <strong>Note:</strong> Kafene does not accept non-traditional banks such as Chime or Varo.
          </p>
          <p className="kafene-bank-data-form__note">
            <strong>Note:</strong> This account will be saved as the preferred payment method for your lease (you can change it later).
          </p>
        </div>

        <BlueBtn
          customClass="kafene-bank-data-form__submit-btn"
          disabled={!valid}
          loading={loading || loadingLease}
          onClick={this.submitForm}
        >
          Continue
        </BlueBtn>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  token: tokenSelector()(state),
  offer: activeStepDataSelector()(state),
  selectedOffer: selectedOfferSelector()(state),
  appRequest: appRequestSelector()(state),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    nextStep: (value) => dispatch(nextStep(value)),
  };
};

KafeneBankDataForm = connect(
  mapStateToProps,
  mapDistpatchToProps
)(KafeneBankDataForm);

export default KafeneBankDataForm;
